import React, { useRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import styles from "./Header.module.css";
import logo from "../assets/arif.png"; // Adjust based on your path
import companyProfilePdf from "../assets/pdf/Arifpay Company Profile 2026 V3.6 .pdf";
import { Link, useNavigate } from "react-router-dom";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileProductsOpen, setMobileProductsOpen] = useState(false);
  const [mobileIndustriesOpen, setMobileIndustriesOpen] = useState(false);
  const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);
  const [industriesOpen, setIndustriesOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [languageOpen, setLanguageOpen] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState("Eng");
  const mobileNavRef = useRef(null);
  const menuButtonRef = useRef(null);
  const aboutDropdownRef = useRef(null);
  const aboutContentRef = useRef(null);
  const productsDropdownRef = useRef(null);
  const productsContentRef = useRef(null);
  const industriesDropdownRef = useRef(null);
  const industriesContentRef = useRef(null);
  const languageSelectRef = useRef(null);
  const languageDropdownRef = useRef(null);
  const navigate = useNavigate();

  const toggleMobileProductsDropdown = () => {
    setMobileProductsOpen(!mobileProductsOpen);
    setMobileIndustriesOpen(false);
    setMobileAboutOpen(false);
  };

  const toggleMobileIndustriesDropdown = () => {
    setMobileIndustriesOpen(!mobileIndustriesOpen);
    setMobileProductsOpen(false);
    setMobileAboutOpen(false);
  };

  const toggleMobileAboutDropdown = () => {
    setMobileAboutOpen(!mobileAboutOpen);
    setMobileProductsOpen(false);
    setMobileIndustriesOpen(false);
  };

  const toggleAboutDropdown = () => {
    setAboutOpen(!aboutOpen);
    setProductsOpen(false);
    setIndustriesOpen(false);
  };

  const toggleProductsDropdown = () => {
    setProductsOpen(!productsOpen);
    setIndustriesOpen(false);
    setAboutOpen(false);
  };

  const toggleIndustriesDropdown = () => {
    setIndustriesOpen(!industriesOpen);
    setProductsOpen(false);
    setAboutOpen(false);
  };

  const toggleLanguageDropdown = () => {
    setLanguageOpen(!languageOpen);
  };

  const changeLanguage = (lang) => {
    setCurrentLanguage(lang);

    setLanguageOpen(false);

    // Here you would implement the logic to change the language of the entire page

    console.log(`Language changed to: ${lang}`);

    // For example, you might use i18n library or update context/state
  };

  const closeAllMenus = () => {
    setMenuOpen(false);
    setProductsOpen(false);
    setIndustriesOpen(false);
    setAboutOpen(false);
    setMobileProductsOpen(false);
    setMobileIndustriesOpen(false);
    setMobileAboutOpen(false);
    setLanguageOpen(false);
  };

  const closeProductsDropdownAndNavigate = (path) => {
    closeAllMenus();
    navigate(path);
  };

  const closeIndustriesDropdownAndNavigate = (path) => {
    closeAllMenus();
    navigate(path);
  };

  const downloadCompanyProfile = () => {
    const link = document.createElement("a");
    link.href = companyProfilePdf;
    link.download = "Arifpay Company Profile 2026 V3.6.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    closeAllMenus();
  };

  useEffect(() => {
    if (!menuOpen) return;

    const scrollY = window.scrollY;
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";

    return () => {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      window.scrollTo(0, scrollY);
    };
  }, [menuOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuOpen &&
        mobileNavRef.current &&
        !mobileNavRef.current.contains(event.target) &&
        menuButtonRef.current &&
        !menuButtonRef.current.contains(event.target)
      ) {
        setMenuOpen(false);

        setMobileProductsOpen(false);
        setMobileIndustriesOpen(false);
        setMobileAboutOpen(false);
      }

      if (
        aboutOpen &&
        aboutContentRef.current &&
        !aboutContentRef.current.contains(event.target) &&
        aboutDropdownRef.current &&
        !aboutDropdownRef.current.contains(event.target)
      ) {
        setAboutOpen(false);
      }

      if (
        productsOpen &&
        productsContentRef.current &&
        !productsContentRef.current.contains(event.target) &&
        productsDropdownRef.current &&
        !productsDropdownRef.current.contains(event.target)
      ) {
        setProductsOpen(false);
      }

      if (
        industriesOpen &&
        industriesContentRef.current &&
        !industriesContentRef.current.contains(event.target) &&
        industriesDropdownRef.current &&
        !industriesDropdownRef.current.contains(event.target)
      ) {
        setIndustriesOpen(false);
      }

      if (
        languageOpen &&
        languageDropdownRef.current &&
        !languageDropdownRef.current.contains(event.target) &&
        languageSelectRef.current &&
        !languageSelectRef.current.contains(event.target)
      ) {
        setLanguageOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen, aboutOpen, productsOpen, industriesOpen, languageOpen]);

  return (
    <header className={styles.header}>
      <div className={styles.topRight}>
        {/* <span className={styles.signUp}>Sign up</span> */}
      </div>

      <div className={styles.navBar}>
        {/* Logo */}

        <div className={styles.logoContainer}>
          <img
            src={logo}
            alt="Arifpay logo"
            className={styles.logo}
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          />
        </div>

        {/* Hamburger Button */}

        <button
          className={styles.menuButton}
          onClick={() => setMenuOpen(!menuOpen)}
          ref={menuButtonRef}
        >
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.333 19.7776C17.333 19.164 17.8305 18.6665 18.4441 18.6665H38.8886C39.5022 18.6665 39.9997 19.164 39.9997 19.7776C39.9997 20.3913 39.5022 20.8887 38.8886 20.8887H18.4441C17.8305 20.8887 17.333 20.3913 17.333 19.7776ZM20.4343 27.7776C20.4343 27.164 20.9318 26.6665 21.5455 26.6665H35.794C36.4077 26.6665 36.9051 27.164 36.9051 27.7776C36.9051 28.3913 36.4077 28.8887 35.794 28.8887H21.5455C20.9318 28.8887 20.4343 28.3913 20.4343 27.7776ZM18.4441 34.6665C17.8305 34.6665 17.333 35.164 17.333 35.7776C17.333 36.3913 17.8305 36.8887 18.4441 36.8887H38.8886C39.5022 36.8887 39.9997 36.3913 39.9997 35.7776C39.9997 35.164 39.5022 34.6665 38.8886 34.6665H18.4441Z"
              fill="#282B27"
            />
          </svg>
        </button>

        {/* Desktop Nav */}

        <nav className={styles.navLinks}>
          <div
            className={styles.dropdown}
            ref={aboutDropdownRef}
            onMouseEnter={() => {
              setAboutOpen(true);
              setProductsOpen(false);
              setIndustriesOpen(false);
            }}
            onMouseLeave={() => setAboutOpen(false)}
          >
            <a
              onClick={toggleAboutDropdown}
              className={styles.dropdownTrigger}
            >
              About Us ▾
            </a>

            {aboutOpen && (
              <div className={styles.aboutDropdownMenu} ref={aboutContentRef}>
                <Link to="/AboutUs" onClick={closeAllMenus}>
                  About Us
                </Link>
                <button
                  type="button"
                  className={styles.aboutDownloadButton}
                  onClick={downloadCompanyProfile}
                >
                  Company Profile
                </button>
              </div>
            )}
          </div>

          <div
            className={styles.dropdown}
            ref={productsDropdownRef}
            onMouseEnter={toggleProductsDropdown}
            onMouseLeave={() => setProductsOpen(false)}
          >
            <a
              onClick={toggleProductsDropdown}
              className={styles.dropdownTrigger}
            >
              Products {productsOpen ? "▾" : "▾"}
            </a>

            {productsOpen && (
              <section
                className={styles.internationalPaymentsSections}
                ref={productsContentRef}
                // onMouseEnter={toggleProductsDropdown}
                // onMouseLeave={() => setProductsOpen(false)}
              >
                <div className={styles.paymentDetails}>
                  {/* LEFT COLUMN */}
                  <div className={styles.leftContent}>
                    <ul className={styles.paymentList}>
                      <li>
                        <Link
                          to="/Gateway"
                          onClick={() =>
                            closeProductsDropdownAndNavigate("/Gateway")
                          }
                        >
                          <h2 style={{color:"green", fontSize:"20px"}}>Payment Channel</h2>
                          <h2
                            style={{
                              fontSize: "1em",
                              marginBottom: "0",
                              marginTop: "8px",
                            }}
                          >
                            ARIF ONLINE PAYMENT
                          </h2>
                          {/* <p
                            style={{ fontSize: "0.8em" }}
                            className={styles.productDescription}
                          >
                            Your Go-To Source For Secure And Convenient Payment
                            Solution.
                            <span className={styles.arrow}>&gt;</span>
                          </p> */}
                        </Link>
                      </li>


                      <li>
                        <Link
                          to="/QrPayment"
                          onClick={() =>
                            closeProductsDropdownAndNavigate("/QrPayment")
                          }
                        >
                          <h3 style={{ fontSize: "1em", marginTop: "0px", marginBottom:'0px' }}>
                           ARIFQR
                          </h3>
                          {/* <p
                            style={{ fontSize: "0.8em" }}
                            className={styles.productDescription}
                          >
                            A fast, secure, and convenient QR code payment
                            designed to simplify transaction.
                            <span className={styles.arrow}>&gt;</span>
                          </p> */}
                        </Link>
                      </li>

                          <li>
                        <Link
                          to="/SmartPos"
                          onClick={() =>
                            closeProductsDropdownAndNavigate("/SmartPos")
                          }
                        >
                          <h3
                            style={{
                              fontSize: "1.1em",
                              marginBottom: "0",
                              marginTop: "0px",
                            }}
                          >
                            ARIFPOS
                          </h3>
                          {/* <p
                            style={{ fontSize: "0.8em" }}
                            className={styles.productDescription}
                          >
                            The Catalyst for the Evolving World of Commerce.
                            <span className={styles.arrow}>&gt;</span>
                          </p> */}
                        </Link>
                      </li>

                                <li>
                        <Link
                          to="/MobilePos"
                          onClick={() =>
                            closeProductsDropdownAndNavigate("/MobilePos")
                          }
                        >
                          <h3 style={{ fontSize: "1em", marginTop: "0px", marginBottom:"0px" }}>
                           ARIF M-POS
                          </h3>
                          {/* <p
                            style={{ fontSize: "0.8em" }}
                            className={styles.productDescription}
                          >
                            Experience the Smart, Sleek, and Simple Payment
                            Solution
                            <span className={styles.arrow}>&gt;</span>
                          </p> */}
                        </Link>
                      </li>

                      
                          <li>
                        <Link
                          to="/Ecommerce"
                          onClick={() =>
                            closeProductsDropdownAndNavigate("/Ecommerce")
                          }
                        >
                          <h3 style={{ fontSize: "1em", marginTop: "0px", marginBottom: "0px" }}>
                            ARIFSHOP
                          </h3>
                        </Link>
                      </li>

                      <li>
                        <Link
                          to="https://arifonlineacademy.com/"
                          onClick={closeAllMenus}
                        >
                          <h3 style={{ fontSize: "1em", marginTop: "0px" }}>
                            ARIF ACADEMY
                          </h3>
                        </Link>
                      </li>
                    </ul>
                  </div>

                  {/* <div className={styles.separatorVerticals}></div> */}

                  {/* MIDDLE COLUMN */}
                  <div className={styles.rightContent}>
                    <ul className={styles.paymentList}>
                  
<h2 style={{color:"green", fontSize:"20px", marginTop:"20px", marginLeft:"20px"}}>Apps</h2>
                      
                      <li>
                        <Link
                          to="/Remittance"
                          onClick={() =>
                            closeProductsDropdownAndNavigate(
                              "/Remittance"
                            )
                          }
                        >
                          <h3 style={{ fontSize: "1em", marginTop: "0", marginBottom:"0" }}>
                           ARIF REMIT
                          </h3>
                          {/* <p
                            style={{ fontSize: "0.8em" }}
                            className={styles.productDescription}
                          >
                            Send money in three clicks.
                            <span className={styles.arrow}>&gt;</span>
                          </p> */}
                        </Link>
                      </li>

            

                      <li>
                        <Link
                          to="/MerchantApp"
                          onClick={() =>
                            closeProductsDropdownAndNavigate(
                              "/MerchantApp"
                            )
                          }
                        >
                          <h3 style={{ fontSize: "1em", marginTop: "0" }}>
                           ARIF MERCHANT
                          </h3>
                          {/* <p
                            style={{ fontSize: "0.8em" }}
                            className={styles.productDescription}
                          >
                            Coming Soon
                            <span className={styles.arrow}>&gt;</span>
                          </p> */}
                        </Link>
                      </li>

                      <li>
                        <Link
                          to="/ArifEqub"
                          onClick={() =>
                            closeProductsDropdownAndNavigate("/ArifEqub")
                          }
                        >
                          <h3 style={{ fontSize: "1em", marginTop: "0", marginBottom: "0" }}>
                            ARIF EQUB
                          </h3>
                        </Link>
                      </li>

                      <li>
                        <Link
                          to="https://artsplus.tv"
                          onClick={closeAllMenus}
                        >
                          <h3 style={{ fontSize: "1em", marginTop: "0", marginBottom: "0" }}>
                            ARTS PLUS
                          </h3>
                        </Link>
                      </li>

                      <li>
                        <Link
                          to="https://jami.bio/"
                          onClick={closeAllMenus}
                        >
                          <h3 style={{ fontSize: "1em", marginTop: "0", marginBottom: "0" }}>
                            JAMI
                          </h3>
                        </Link>
                      </li>

                    </ul>
                  </div>

                  {/* <div className={styles.separatorVerticals}></div> */}

                  {/* RIGHT COLUMN - Coming Soon Products with links */}
                  <div className={styles.comingSoonContent}>
                    <h2 style={{ color: "green", marginBottom: "20px", fontSize:"20px" }}>
                      Coming Soon
                    </h2>
                    <ul className={styles.paymentList}>
                      <li>
                        <Link
                          to="/CarParking"
                          onClick={() =>
                            closeProductsDropdownAndNavigate(
                              "/CarParking"
                            )
                          }
                        >
                          <h3
                            style={{
                              fontSize: "1em",
                              marginBottom: "0",
                              marginTop: "0",
                            }}
                          >
                            ARIF INSURANCE
                          </h3>
                          {/* <p
                            style={{ fontSize: "0.8em" }}
                            className={styles.productDescription}
                          >
                            Web-based POS to accept payments online.
                            <span className={styles.arrow}>&gt;</span>
                          </p> */}
                        </Link>
                      </li>

                      <li>
                        <Link
                          to="/Wallet"
                          onClick={() =>
                            closeProductsDropdownAndNavigate("/Wallet")
                          }
                        >
                          <h3 style={{ fontSize: "1em", marginBottom: "0", marginTop:"0" }}>
                           ARIF WALLET
                          </h3>
                          {/* <p
                            style={{ fontSize: "0.8em" }}
                            className={styles.productDescription}
                          >
                            A self-checkout experience for faster service.
                            <span className={styles.arrow}>&gt;</span>
                          </p> */}
                        </Link>
                      </li>


                      <li>
                        <Link
                          to="/HealthCare"
                          onClick={() =>
                            closeProductsDropdownAndNavigate(
                              "/HealthCare"
                            )
                          }
                        >
                          <h3 style={{ fontSize: "1em", marginTop: "0", marginBottom:'0' }}>
                            ARIF CREDIT
                          </h3>
                        </Link>
                      </li>

                      <li>
                        <Link
                          to="/arif-e-invoice"
                          onClick={() =>
                            closeProductsDropdownAndNavigate("/arif-e-invoice")
                          }
                        >
                          <h3 style={{ fontSize: "1em", marginTop: "0", marginBottom: "0" }}>
                            ARIF ELECTRONIC SALES REGISTRATION
                          </h3>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </section>
            )}
          </div>

          {/* <Link to="/pages/Developers" onClick={closeAllMenus}>
            Developers
          </Link> */}

          {/* <Link to="/pages/Pricing" onClick={closeAllMenus}>
            Pricing
          </Link> */}

          <div
            className={styles.dropdown}
            ref={industriesDropdownRef}
            onMouseEnter={toggleIndustriesDropdown}
            onMouseLeave={() => setIndustriesOpen(false)}
          >
            <a
              onClick={toggleIndustriesDropdown}
              className={styles.dropdownTrigger}
            >
              Industries {industriesOpen ? "▾" : "▾"}
            </a>

            {industriesOpen && (
              <section
                className={styles.internationalPaymentsSection}
                ref={industriesContentRef}
                // onMouseEnter={toggleIndustriesDropdown}
                // onMouseLeave={() => setIndustriesOpen(false)}
              >
                <div className={styles.paymentDetails}>
                  <div className={styles.leftContent}>
                    <ul className={styles.paymentLists}>
                      <li>
                        <Link
                          to="/Msmes"
                          onClick={() =>
                            closeIndustriesDropdownAndNavigate("/Msmes")
                          }
                        >
                          <h4 style={{ fontSize: "1em" }}>MSMEs</h4>

                          <p
                            style={{ fontSize: "0.8em" }}
                            className={styles.productDescription}
                          >
                            we are the back bone of each small to medium scale
                            business
                            {/* <span className={styles.arrow}>&gt;</span> */}
                          </p>
                        </Link>
                      </li>

                      <li>
                        <Link
                          to="/Retail"
                          onClick={() =>
                            closeIndustriesDropdownAndNavigate("/Retail")
                          }
                        >
                          <h4 style={{ fontSize: "1em" }}>Retail</h4>

                          <p
                            style={{ fontSize: "0.8em" }}
                            className={styles.productDescription}
                          >
                            work together for different retail bussiness
                            {/* <span className={styles.arrow}>&gt;</span> */}
                          </p>
                        </Link>
                      </li>
                    </ul>
                  </div>

                  {/* <div className={styles.separatorVertical}></div> */}

                  <div className={styles.rightContent}>
                    <ul className={styles.paymentList}>
                      <li>
                        <Link
                          to="/Hospitality"
                          onClick={() =>
                            closeIndustriesDropdownAndNavigate(
                              "/Hospitality"
                            )
                          }
                        >
                          <h4 style={{ fontSize: "1em" }}>
                            Hospitality and Leisure
                          </h4>

                          <p
                            style={{ fontSize: "0.8em" }}
                            className={styles.productDescription}
                          >
                            Have a look at our impact in hospitality sector.
                            {/* <span className={styles.arrow}>&gt;</span> */}
                          </p>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/Transportation"
                          onClick={() =>
                            closeIndustriesDropdownAndNavigate(
                              "/Transportation"
                            )
                          }
                        >
                          <h4 style={{ fontSize: "1em" }}>Transportation</h4>

                          <p
                            style={{ fontSize: "0.8em" }}
                            className={styles.productDescription}
                          >
                            Revolutionizing Transportation Payments
                            {/* <span className={styles.arrow}>&gt;</span> */}
                          </p>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </section>
            )}
          </div>
              <Link to="https://developer.arifpay.net/" onClick={closeAllMenus}>
            Developers
          </Link>
        </nav>

        {/* Mobile Nav — portaled to body so it scrolls independently of the page */}
        {menuOpen &&
          createPortal(
            <div className={styles.mobileNavLinks} ref={mobileNavRef}>
              <div className={styles.mobileDropdown}>
                <button
                  onClick={toggleMobileAboutDropdown}
                  className={styles.mobileDropdownToggle}
                >
                  About Us {mobileAboutOpen ? "▲" : "▼"}
                </button>

                {mobileAboutOpen && (
                  <div className={styles.mobileDropdownContent}>
                    <Link to="/AboutUs" onClick={closeAllMenus}>
                      About Us
                    </Link>
                    <button
                      type="button"
                      className={styles.mobileDownloadButton}
                      onClick={downloadCompanyProfile}
                    >
                      Company Profile
                    </button>
                  </div>
                )}
              </div>

              <div className={styles.mobileDropdown}>
                <button
                  onClick={toggleMobileProductsDropdown}
                  className={styles.mobileDropdownToggle}
                >
                  Products {mobileProductsOpen ? "▲" : "▼"}
                </button>

                {mobileProductsOpen && (
                  <div className={styles.mobileDropdownContent}>
                    <Link to="/Gateway" onClick={closeAllMenus}>
                      ARIF ONLINE PAYMENT
                    </Link>
                    <Link to="/Remittance" onClick={closeAllMenus}>
                      ARIF REMIT
                    </Link>
                    <Link to="/QrPayment" onClick={closeAllMenus}>
                      ARIFQR
                    </Link>
                    <Link to="/SmartPos" onClick={closeAllMenus}>
                      ARIFPOS
                    </Link>
                    <Link to="/MobilePos" onClick={closeAllMenus}>
                      ARIF M-POS
                    </Link>
                    <Link to="/MerchantApp" onClick={closeAllMenus}>
                      ARIF MERCHANT
                    </Link>
                    <Link to="/ArifEqub" onClick={closeAllMenus}>
                      ARIF EQUB
                    </Link>
                    <Link
                      to="https://artsplus.tv"
                      onClick={closeAllMenus}
                    >
                      ARTS PLUS
                    </Link>
                    <Link
                      to="https://jami.bio/"
                      onClick={closeAllMenus}
                    >
                      JAMI
                    </Link>
                    <Link to="/Ecommerce" onClick={closeAllMenus}>
                      ARIFSHOP
                    </Link>
                    <Link
                      to="https://arifonlineacademy.com/"
                      onClick={closeAllMenus}
                    >
                      ARIF ACADEMY
                    </Link>

                    <hr />
                    <span className={styles.dropdownHeader}>Coming Soon</span>
                    <Link to="/CarParking" onClick={closeAllMenus}>
                      ARIF INSURANCE
                    </Link>
                    <Link to="/Wallet" onClick={closeAllMenus}>
                      ARIF WALLET
                    </Link>
                    <Link to="/HealthCare" onClick={closeAllMenus}>
                      ARIF CREDIT
                    </Link>
                    <Link to="/arif-e-invoice" onClick={closeAllMenus}>
                      ARIF ELECTRONIC SALES REGISTRATION
                    </Link>
                  </div>
                )}
              </div>

              <Link to="https://developer.arifpay.net/" onClick={closeAllMenus}>
                Developers
              </Link>

              <div className={styles.mobileDropdown}>
                <button
                  onClick={toggleMobileIndustriesDropdown}
                  className={styles.mobileDropdownToggle}
                >
                  Industries {mobileIndustriesOpen ? "▲" : "▼"}
                </button>

                {mobileIndustriesOpen && (
                  <div className={styles.mobileDropdownContent}>
                    <Link to="/Msmes" onClick={closeAllMenus}>
                      MSMEs
                    </Link>
                    <Link to="/Retail" onClick={closeAllMenus}>
                      RETAIL
                    </Link>
                    <Link to="/Hospitality" onClick={closeAllMenus}>
                      HOSPITALITY and LEISURE
                    </Link>
                    <Link to="/Transportation" onClick={closeAllMenus}>
                      TRANSPORTATION
                    </Link>
                  </div>
                )}
              </div>
            </div>,
            document.body
          )}

        <div className={styles.actions}>
          <div className={styles.languageSelect} ref={languageSelectRef}>
            <div
              onClick={toggleLanguageDropdown}
              className={styles.currentLanguage}
            >
              🌐 {currentLanguage} ▾
            </div>

            {languageOpen && (
              <div
                className={styles.languageDropdown}
                ref={languageDropdownRef}
              >
                {currentLanguage !== "Eng" && (
                  <div
                    onClick={() => changeLanguage("Eng")}
                    className={styles.languageOption}
                  >
                    🌐 Eng
                  </div>
                )}

                {/* {currentLanguage !== "አማርኛ" && (
                  <div
                    onClick={() => changeLanguage("አማርኛ")}
                    className={styles.languageOption}
                  >
                    🌐 አማርኛ
                  </div>
                )} */}
              </div>
            )}
          </div>

          <Link to="/ContactUs">
            <button className={styles.primaryButton}>Contact Us</button>
          </Link>
        </div>
      </div>

      <hr className={styles.headerLine} />
    </header>
  );
};

export default Header;
